import { Injectable } from '@angular/core';
import { NewsModel } from 'src/app/models/NewsModel';

@Injectable({
  providedIn: 'root'
})
export class NewsStore {

  showLoader: boolean;
  totalRecords: number;
  news: NewsModel[];
  totalPages: number;
  pageSize = 10;

  constructor() {
    this.news = [];
  }

  loadNews(news: NewsModel[]) {
    this.news = news.sort((news1, news2) => news1.position - news2.position);
  }

  updateTotalPages() {
    this.totalPages = Math.ceil((this.news.length / this.pageSize));
  }
}
